document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.shopify-policy__container, main .rte, main > div');
  if (!container) return;

  const headings = container.querySelectorAll('h2');
  if (headings.length === 0) return;

  // Wrap existing content
  const contentWrapper = document.createElement('div');
  contentWrapper.className = 'policy-content-wrapper';
  while (container.firstChild) {
    contentWrapper.appendChild(container.firstChild);
  }

  // Create sidebar
  const sidebar = document.createElement('aside');
  sidebar.className = 'policy-toc-sidebar';
  sidebar.innerHTML = `
    <p class="policy-toc-sidebar-title">Jump to section</p>
    <nav>
      <ul class="policy-toc-list" id="PolicyTOCList"></ul>
    </nav>
  `;

  container.classList.add('policy-page-wrapper');
  container.appendChild(sidebar);
  container.appendChild(contentWrapper);

  // Build TOC links
  const tocList = sidebar.querySelector('#PolicyTOCList');
  headings.forEach((heading, i) => {
    if (!heading.id) heading.id = 'policy-section-' + i;

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + heading.id;
    a.className = 'policy-toc-link';
    a.textContent = heading.textContent.trim();
    a.addEventListener('click', (e) => {
      e.preventDefault();
      heading.scrollIntoView({ behavior: 'smooth' });
    });
    li.appendChild(a);
    tocList.appendChild(li);
  });

  // Active state on scroll
  const links = tocList.querySelectorAll('.policy-toc-link');
  const targets = Array.from(headings);

  function setActive() {
    let current = targets[0];
    for (const target of targets) {
      if (target.getBoundingClientRect().top <= 120) current = target;
    }
    links.forEach((link) => {
      const id = link.getAttribute('href').slice(1);
      link.classList.toggle('is-active', id === current.id);
    });
  }

  window.addEventListener('scroll', setActive, { passive: true });
  setActive();
});